export default "__VITE_ASSET__BzW6YCON__"